import { useState, useEffect, FC, ReactNode } from "react";
import ThemeContext from "./theme-context";

export default function ThemeContextWrapper({
  children,
}: React.PropsWithChildren<{}>) {
  const [theme, setTheme] = useState("light"); // useState(localStorage.getItem("theme") || "light");

  const changeCurrentTheme = (newTheme: "light" | "dark") => {
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  useEffect(() => {
    if (theme === "light") document.body.classList.remove("dark");
    else document.body.classList.add("dark");
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ currentTheme: theme, changeCurrentTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
